export function timeToSeconds(timeString) {
  const timeParts = timeString.split(":");
  const seconds = parseInt(timeParts.pop(), 10) || 0;
  const minutes = parseInt(timeParts.pop(), 10) || 0;
  const hours = parseInt(timeParts.pop(), 10) || 0;
  return hours * 3600 + minutes * 60 + seconds;
}
